export default "__VITE_ASSET__CAJ8sKp0__"